import { render, staticRenderFns } from "./siderBar.vue?vue&type=template&id=0364681c"
import script from "./siderBar.vue?vue&type=script&lang=js"
export * from "./siderBar.vue?vue&type=script&lang=js"
import style0 from "./siderBar.vue?vue&type=style&index=0&id=0364681c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports